// extracted by mini-css-extract-plugin
module.exports = {"card":"SimpleStatsLinkCard_card__1S2Er"};